import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { readJSON, writeJSON } from '@/lib/storage'
import { useStores } from '@/stores'
import { entryActive, findActiveEntry, itemsByPath } from './menuModel'

/** A menu page the user opened, newest first; labels come from the menu, so they follow the language. */
export type RecentPage = { path: string; search?: string; label: string; area: string }

const LIMIT = 8
const key = (profileId: string) => `mf.recent.${profileId}`

export function readRecentPages(profileId: string): RecentPage[] {
  const saved = readJSON<RecentPage[]>(key(profileId), [])
  return Array.isArray(saved) ? saved.filter((page) => itemsByPath.has(page.path)) : []
}

export function clearRecentPages(profileId: string) {
  writeJSON(key(profileId), [])
}

/**
 * Remembers each menu page the user opens (this browser, per profile) for the
 * start page's «Недавние». The dashboard itself and detail routes are not
 * menu pages and are skipped.
 */
export function useRecordRecentPage() {
  const { session } = useStores()
  const { pathname, search } = useLocation()
  const profileId = session.profile?.id

  useEffect(() => {
    if (!profileId || pathname === '/') return
    const current = new URLSearchParams(search)
    const found = findActiveEntry(session, (entry) => Boolean(itemsByPath.get(entry.path)) && entryActive(entry, pathname, current, session.menuAreas))
    if (!found) return
    const page: RecentPage = { path: found.entry.path, search: found.entry.search, label: found.entry.label, area: found.trail[0] }
    const same = (other: RecentPage) => other.path === page.path && (other.search ?? '') === (page.search ?? '')
    writeJSON(key(profileId), [page, ...readRecentPages(profileId).filter((other) => !same(other))].slice(0, LIMIT))
  }, [pathname, search, profileId, session])
}
